import Api from '@/services/Api'

export default {
  get () {
    return Api().get('user-profiles').then(function (response) {
      return (response)
    })
  },
  getById(id) {
    return Api().get(`user-profiles/${id}`).then(function (response) {
      return (response)
    })
  },
  add(data) {
    return Api().post('user-profiles', data).then(function (response) {
      return (response)
    })
  },
  partialUpdate(id, data) {
    return Api().patch(`user-profiles/${id}`, data).then(function (response) {
      return (response)
    })
  }
}